import React from 'react'
import Box from '../../../../Box'

export default (type, element, content, children, key) => (
  <Box
    key={key}
    fontWeight={500}
    display='inline'
  >
    {children}
  </Box>
)
